import React from "react";
import { generatePath, useHistory } from "react-router-dom";
import { useTranslation } from "locales";
import useModalLinkPrinter from "hooks/useModalLinkPrinter";
import BaseButton from "components/BaseButton";
import ConferenceShare from "components/ConferenceShare";
import ModalWindow from "components/ModalWindow";
import "./style.scss";
import { Routes } from "../../router/config";

function ConferenceModal({
  show = false,
  onClose,
  conferenceUuid,
}: {
  show?: boolean;
  onClose: () => void;
  conferenceUuid: string;
}) {
  const { getLocation } = useModalLinkPrinter();
  const history = useHistory();
  const { t } = useTranslation();

  const onClickStart = () => {
    history.push(getLocation(generatePath(Routes.conferenceJoinByConferenceUuid, { conferenceUuid })));
    onClose();
  };

  return (
    <ModalWindow show={show} onClose={onClose} className={"conference-modal"}>
      <ConferenceShare
        conferenceUuid={conferenceUuid}
        customCaption={t("Share link")}
        customText={t("By clicking Start you will start a new conference.")}
      />
      <div className="conference-modal__buttons">
        <BaseButton className="conference-modal__btn" outline large onClick={onClose}>
          {t("Close")}
        </BaseButton>
        <BaseButton className="conference-modal__btn" large onClick={onClickStart}>
          {t("Start")}
        </BaseButton>
      </div>
    </ModalWindow>
  );
}

export default ConferenceModal;
